import { render } from "./kenaikan-pangkat.vue?vue&type=template&id=4a3103c8"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__